// extracted by mini-css-extract-plugin
export default {"bg_white":"SectionMain_bg_white__eMzhe","items":"SectionMain_items__jKXcs","googleIcon":"SectionMain_googleIcon__NG44x"};